module.exports = __webpack_public_path__ + "assets/logoless.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logoless.gif
 ** module id = 16
 ** module chunks = 1
 **/